/**
* This object builds out an overflow menu (when needed) for subnavigation items on section front templates
*/
class NavSectionSubnav {
	constructor() {

		// Navigation wrapper
		const sectionSubnavContainer = document.querySelector( '.section-front-navigation' );

		// if subnav doesn't exist, bail out so we don't throw an error
		if ( ! sectionSubnavContainer ) {
			return;
		}

		const sectionSubnavList = sectionSubnavContainer.querySelector( '.section-front-subnav' );

		// Calculated witdhs
		var menuSpaceNeeded = this.getMenuSpaceNeeded( sectionSubnavContainer );
		var menuSpaceAvailable = this.getMenuAvailableSpace( sectionSubnavContainer );

		// Nav items
		var sectionNavItems = document.querySelectorAll( '.section-front-navigation .section-front-subnav > .menu-item' );
		var sectionNavItemsCount = sectionNavItems.length;

		// Caching variables
		var obj;
		var j;

		// Building out the "More" container for overflow items
		var moreMenuBucket = this.createMoreBucket();

		// Put it at the end of the line
		sectionSubnavList.appendChild( moreMenuBucket );

		// If the space needed is more than the available space in the UI, we need to build the overflow menu out
		if( menuSpaceNeeded >= menuSpaceAvailable ) {

			// Show the menu
			this.showElement( document.getElementById( 'bucket-more-parent' ), 'inline-block' );

			// Loop though all the menu items and when we hit the max width, put them in the overflow
			if ( sectionNavItemsCount ) {

				for ( j = 0; j < sectionNavItemsCount; j = j + 1 ) {

					obj = sectionNavItems[j];

					// move flagged objects into the overflow container
					if ( obj.classList.contains( 'add-to-overflow' ) ) {

						this.addToMoreBucket( obj );

					}

				} // for
			} // if

		} else {

			// Hide the menu ( just in case it's showing )
			this.hideElement( document.getElementById( 'bucket-more-parent' ), 'none' );

		} // if space is needed

		// Events
		// The sub-menu will open on :focus in the CSS, so we don't need extra JS for that, but it's a dead link (#!) so we're just preventing it from firing
		document.getElementById( 'bucket-more-link' ).addEventListener( 'click', function( e ) {
			e.preventDefault();
		} );

	} // constructor

	/**
	* Hide an element
	*/
	hideElement( el, displayProperty ) {
		el.style.display = displayProperty;
		el.setAttribute( 'aria-hidden', 'true');
	}

	/**
	* Show an element
	*/
	showElement( el, displayProperty ) {
		el.style.display = displayProperty;
		el.setAttribute( 'aria-hidden', 'false');
	}

	/**
	* Add an item into the "more" bucket
	*/
	addToMoreBucket( el ) {

		document.getElementById( 'bucket-more-menu' ).appendChild( el );

	} // addToMoreBucket()

	/**
	* Create "More" menu item so it can be added to the UI
	*/
	createMoreBucket() {

		// Building out the "More" container for overflow items
		var moreMenuBucket = document.createElement( 'li' );

		// Set standard WP classes & an ID on the link bucket
		moreMenuBucket.setAttribute( 'class', 'menu-item menu-item-has-children' );
		moreMenuBucket.setAttribute( 'id', 'bucket-more-parent' );

		// Hide it by default, because we may not need it yet
		moreMenuBucket.setAttribute( 'aria-hidden', 'true' );
		moreMenuBucket.style.display = 'none';

		// Build out the subNav catcher
		var moreMenuCatcher = document.createElement( 'ul' );
		moreMenuCatcher.setAttribute( 'class', 'sub-menu' );
		moreMenuCatcher.setAttribute( 'id', 'bucket-more-menu' );

		// Budiling out the link trigger inside the "More" container
		var moreMenuLink = document.createElement( 'a' );
		var moreMenuLinkContent = document.createTextNode( 'More' );
		moreMenuLink.setAttribute( 'id', 'bucket-more-link' );

		moreMenuLink.setAttribute( 'href', '#!' );
		moreMenuLink.setAttribute( 'role', 'button' );

		// Add content to the link
		moreMenuLink.appendChild( moreMenuLinkContent );

		// Putting the link and catcher inside their container
		moreMenuBucket.appendChild( moreMenuLink );
		moreMenuBucket.appendChild( moreMenuCatcher );

		return moreMenuBucket;

	} // createMoreBucket()

	/**
	* Return how much space the menu needs based on how many items are in it and the box model calculations
	*/
	getMenuSpaceNeeded( nav ) {

		// Caching and setting some variables
		var navItems = nav.querySelectorAll( '.section-front-subnav > .menu-item' );
		var navItemsCount = navItems.length;
		var navObjStyle;
		var navItemsSingle;
		var navItemsSingleWidth;
		var navItemsSingleMarginLeft;
		var navItemsSingleMarginRight;
		var navItemsSinglePaddingLeft;
		var navItemsSinglePaddingRight;
		var navItemsSinglePadding;
		var totalWidth;
		var navItemsTotalWidth = 150; // start it at 150 to give us some spacing on the right
		var i;

		// Loop through each nav item and get total the width
		if ( navItemsCount ) {
			for ( i = 0; i < navItemsCount; i = i + 1 ) {

				navItemsSingle = navItems[i];
				navObjStyle = navItemsSingle.currentStyle || window.getComputedStyle( navItemsSingle );
				navItemsSingleWidth = navItemsSingle.offsetWidth;
				navItemsSingleMarginLeft = Number( navObjStyle.marginLeft.replace('px', '') );
				navItemsSingleMarginRight = Number( navObjStyle.marginRight.replace('px', '') ); // Should be 0, but just in case it changes in the future
				navItemsSinglePaddingLeft = Number( navObjStyle.paddingLeft.replace('px', '') ); // Should be 0, but just in case it changes in the future
				navItemsSinglePaddingRight = Number( navObjStyle.paddingRight.replace('px', '') ); // Should be 0, but just in case it changes in the future

				// Add up all the widths
				totalWidth = navItemsSingleWidth + navItemsSingleMarginLeft + navItemsSingleMarginRight + navItemsSinglePaddingLeft + navItemsSinglePaddingRight;

				// Add this width to the overall witdh
				navItemsTotalWidth = totalWidth + navItemsTotalWidth;

				if ( this.getMenuAvailableSpace( nav ) <= navItemsTotalWidth ) {
					navItemsSingle.classList.add( 'add-to-overflow' );
				}

			} // for
		} // if

		return navItemsTotalWidth;

	} // getMenuItems()

	/**
	* Return the amount of space in nav
	*/
	getMenuAvailableSpace( nav ) {

		return nav.offsetWidth;

	} // getMenuItems()


} // NavSectionSubnav

export default NavSectionSubnav;



// WEBPACK FOOTER //
// ./assets/components/navSection/navSectionSubnav.js